import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IIpAllowListApiResult } from '../types/IpAllowList';

/**
 * Parameters for creating the IP allowlist
 */
export interface ICreateIpAllowListParams {
    allowedIPs: string[];
}

/**
 * Result containing the created IP allowlist information
 */
export interface ICreateIpAllowListResult extends IIpAllowListApiResult {
}

/**
 * Request class for creating the IP allowlist configuration
 * @example
 * const request = new CreateIpAllowListRequest({ allowedIPs: ['192.168.1.1', '10.0.0.0/24'] });
 * const result = await WebHttpClient.sendRequest(request);
 */
export class CreateIpAllowListRequest extends Request<ICreateIpAllowListParams, ICreateIpAllowListResult> {
    constructor(params: ICreateIpAllowListParams) {
        super('createIpAllowList', params);
    }
}
